import { Component } from '@angular/core';

@Component({
    selector: 'app-imprint-page',
    templateUrl: './imprint-page.component.html',
    styleUrls: ['./imprint-page.component.scss'],
    standalone: false
})
export class ImprintPageComponent {

}
